import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Tag } from "./Reveal";

export const SectionHead = ({ index, eyebrow, title, text, center = false }) => (
  <Reveal className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    <div className="flex items-center gap-3">
      {index && <span className="font-mono text-sm text-spark">{index}</span>}
      <Tag>{eyebrow}</Tag>
      <span className="h-px flex-1 bg-seam" />
    </div>
    <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight leading-[0.95] text-frost">
      {title}
    </h2>
    {text && <p className="mt-5 text-base sm:text-lg leading-relaxed text-cadmium">{text}</p>}
  </Reveal>
);

export const PrimaryBtn = ({ to, href, children, testid, onClick, className = "" }) => {
  const cls = `group inline-flex items-center gap-3 bg-gold px-7 py-4 font-display text-base font-bold uppercase tracking-wider text-white transition-colors duration-300 hover:bg-spark ember-glow ${className}`;
  const inner = (
    <>
      {children}
      <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
    </>
  );
  if (to) return <Link to={to} data-testid={testid} className={cls} onClick={onClick}>{inner}</Link>;
  if (href) return <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={cls} onClick={onClick}>{inner}</a>;
  return <button type="submit" data-testid={testid} className={cls} onClick={onClick}>{inner}</button>;
};

export const GhostBtn = ({ to, href, children, testid, className = "" }) => {
  const cls = `group inline-flex items-center gap-3 border border-seam px-7 py-4 font-display text-base font-bold uppercase tracking-wider text-frost transition-colors duration-300 hover:border-spark hover:text-spark ${className}`;
  const inner = (
    <>
      {children}
      <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
    </>
  );
  if (to) return <Link to={to} data-testid={testid} className={cls}>{inner}</Link>;
  return <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={cls}>{inner}</a>;
};
